import {HttpClient, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {
    DEFAULT_PAGE_EVENT,
    IPagedData,
    IPagedSearch,
    IPermission,
    IPermissionActivate,
    IPermissionCreate,
    mongoQueryParser,
} from '@evencel/models';
import {Observable} from 'rxjs';

export const PERMISSION_URL = 'permissions';

@Injectable({providedIn: 'root'})
export class PermissionService {
    httpClient = inject(HttpClient);

    post(data: IPermissionCreate): Observable<IPermission> {
        return this.httpClient.post<IPermission>(PERMISSION_URL, data);
    }

    patch(data: IPermission): Observable<IPermission> {
        const url = `${PERMISSION_URL}/${data._id}`;
        return this.httpClient.patch<IPermission>(url, data);
    }

    activate(data: IPermissionActivate): Observable<IPermission> {
        const {active} = data;
        const url = `${PERMISSION_URL}/${data._id}/activate`;
        return this.httpClient.patch<IPermission>(url, {active});
    }

    delete(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${PERMISSION_URL}/${id}`);
    }

    restore(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${PERMISSION_URL}/${id}/restore`);
    }

    private searchParams(data: IPagedSearch) {
        const {active, direction} = data.sort;
        const {pageIndex, pageSize} = data.page;
        let params = new HttpParams();
        params = params.append('pageIndex', `${pageIndex}`);
        params = params.append('pageSize', `${pageSize}`);
        params = params.append('sort', active);
        params = params.append('order', direction);
        params = params.append('projection', data.projection || 'dataTable');
        return params;
    }

    searchByName<T = IPermission>(name: string) {
        const condition = mongoQueryParser.parse({name: {$regex: name}, system: {$eq: false}});
        const action: IPagedSearch = {
            page: {
                ...DEFAULT_PAGE_EVENT,
                pageSize: 100,
            },
            condition,
            sort: {
                active: 'name',
                direction: 'asc',
            },
        };
        return this.search<T>(action);
    }

    search<T = IPermission>(data: IPagedSearch): Observable<IPagedData<T>> {
        const params = this.searchParams(data);
        return this.httpClient.post<IPagedData<T>>(`${PERMISSION_URL}/search`, data.condition, {params});
    }

    getOne(id: string): Observable<IPermission> {
        let params = new HttpParams();
        params = params.append('projection', `form`);
        const url = `${PERMISSION_URL}/${id}`;
        return this.httpClient.get<IPermission>(url, {params});
    }

    get(data: IPagedSearch): Observable<IPagedData<IPermission>> {
        const params = this.searchParams(data);
        return this.httpClient.get<IPagedData<IPermission>>(PERMISSION_URL, {
            params,
        });
    }
}
